/* jshint esversion: 6, -W097, -W040 */
/* globals module, require */
'use strict';

/**
 * @module enervee_utils.ads
 * <native-ad-slot></native-ad-slot>
 */


function nativeAdSlotDirective() {
    return {
        restrict: 'E',
        scope: {
            tagname: '<',
            categoryId: '<?',
            showTagEvent: '<?',
            adLoaded: '=?',
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: nativeAdSlotController,
        template: require('./nativeAdSlotView.html'),
    };
}

nativeAdSlotController.$inject = [
    '$q',
    '$scope',
    'NativeAdsService',
];
function nativeAdSlotController(
    $q,
    $scope,
    NativeAdsService
) {
    this.$onInit = function () {
        const vm = this;
        vm.adLoaded = false;
        vm.trackAdViewed = trackAdViewed;
        vm.trackAdClicked = trackAdClicked;

        if (vm.showTagEvent) {
            let showTagHandler = $scope.$on(vm.showTagEvent, () => {
                loadAd();
                showTagHandler();  // stop listening for this event
            });
        } else {
            loadAd();
        }

        /**
         * Requests the ads config object from the CMS (or loads it from the stored response),
         * then marks the upwards-only property 'adLoaded' as true.
         */
        function loadAd() {
            return NativeAdsService.getAd(vm.tagname, vm.categoryId).then(ad => {
                vm.ad = ad;
                vm.adLoaded = true;
            });
        }

        function trackAdViewed() {
            return trackAdInteraction('Native Ad Viewed', 'ad viewed');
        };

        function trackAdClicked() {
            return trackAdInteraction('Native Ad Engaged', 'ad clicked');
        };

        /**
         * Helper function to abstract tracking interactions with ads.
         * Any tracking triggered before the ad is actually loaded is ignored,
         * since the user likely interacted with it by accident.
         * 
         * @param {string} event The name of the event
         * @param {string} action The desired action being tracked
         */
        function trackAdInteraction(event, action) {
            if (!vm.adLoaded) return $q.resolve();
            return NativeAdsService.trackAdInteraction(event, action, vm.tagname, vm.ad, vm.categoryId);
        }
    };
}

module.exports = nativeAdSlotDirective;
